/** French labels + paths for admin nav / breadcrumbs (SSOT). */

export const INVENTAIRE_CLUSTER_LABEL = 'Inventaire';

export const ADMIN_PRODUCTS = {
  path: '/catalog',
  label: 'Produits',
} as const;

export const ADMIN_STOCK_MOVEMENTS = {
  path: '/inventory',
  /** Compact nav / view switcher */
  shortLabel: 'Mvts de Stock',
  /** Page title + breadcrumb leaf */
  pageLabel: 'Mvts de Stock',
} as const;

export const ADMIN_LOTS = {
  path: '/inventory/lots',
  shortLabel: 'Lots',
  pageLabel: 'Lots',
} as const;

export const ADMIN_LOCATIONS = {
  path: '/inventory/locations',
  label: 'Emplacements',
} as const;

/** Inventaire cluster ViewMenu (Lots | Mvts | Emplacements). */
export const INVENTAIRE_VIEW_MENU_ITEMS = [
  { value: 'lots' as const, label: ADMIN_LOTS.shortLabel, path: ADMIN_LOTS.path },
  {
    value: 'movements' as const,
    label: ADMIN_STOCK_MOVEMENTS.shortLabel,
    path: ADMIN_STOCK_MOVEMENTS.path,
  },
  { value: 'locations' as const, label: ADMIN_LOCATIONS.label, path: ADMIN_LOCATIONS.path },
] as const;

export type InventaireViewMenuValue = (typeof INVENTAIRE_VIEW_MENU_ITEMS)[number]['value'];

export function inventaireViewMenuPath(value: string): string | null {
  const hit = INVENTAIRE_VIEW_MENU_ITEMS.find((i) => i.value === value);
  return hit?.path ?? null;
}

export const ADMIN_LEAD_FLOWS = {
  path: '/crm/flows',
  label: 'Parcours',
} as const;

export const ADMIN_USERS = {
  path: '/users',
  label: 'Utilisateurs',
  pageTitle: 'Utilisateurs',
} as const;

export const ADMIN_ROLES = {
  path: '/roles',
  label: 'Rôles',
  pageTitle: 'Rôles',
} as const;

export const ADMIN_DATA_SOURCES = {
  path: '/settings/data-sources',
  label: 'Sources GTIN',
} as const;

export const ADMIN_PROCUREMENT_QUOTES = {
  path: '/procurement/quotes',
  label: 'Devis RFQ',
} as const;
